document.querySelectorAll('.mobile-switch-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const idx = btn.dataset.index;
    document.querySelectorAll('.mobile-switch-btn')
      .forEach(b => b.classList.toggle('active', b === btn));
    document.querySelectorAll('.mobile-compare').forEach(cell => {
      cell.style.display = (cell.dataset.index === idx) ? 'flex' : 'none';
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-type="section-vs"]');
  if (!section) return;

  const START_DELAY = 300;
  let active = false;
  const timeouts = new Set();
  let startTimer = null;

  const getItems = () => {
    const items = [];
    section.querySelectorAll('.cell.block-row-icon').forEach(cell => {
      const group = cell.querySelector('.vs__svg-container');
      if (group) items.push(group);
      else {
        const icon = cell.querySelector('svg.check-icon');
        if (icon) items.push(icon);
      }
    });
    section.querySelectorAll('.mobile-row').forEach(row => {
      const mainCell = row.querySelector('.mobile-cell.mobile-main');
      if (mainCell) {
        const group = mainCell.querySelector('.vs__svg-container');
        if (group) items.push(group);
        else {
          const icon = mainCell.querySelector('svg.check-icon');
          if (icon) items.push(icon);
        }
      }
      row.querySelectorAll('.mobile-cell.mobile-compare').forEach(cell => {
        const icon = cell.querySelector('svg.check-icon');
        if (icon) items.push(icon);
      });
    });
    return items;
  };

  const activate = () => {
    const items = getItems();
    items.forEach((el, idx) => {
      const t = setTimeout(() => {
        el.style.background = 'var(--secondary-carmin, #E64010)';
      }, idx * 200);
      timeouts.add(t);
    });
  };

  const reset = () => {
    if (startTimer) {
      clearTimeout(startTimer);
      startTimer = null;
    }
    timeouts.forEach(t => clearTimeout(t));
    timeouts.clear();
    getItems().forEach(el => {
      el.style.background = '';
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!active) {
          reset();
          startTimer = setTimeout(() => {
            activate();
            active = true;
          }, START_DELAY);
        }
      } else {
        reset();
        active = false;
      }
    });
  }, { threshold: 0 });

  observer.observe(section);
});



